import { memo, useCallback, useMemo } from "react";
import { Paper, Stack, Typography } from "@mui/material";
import { ExtraSmallButton } from "../../custom";
import SwapTradesIcon from "../../../assets/icons/SwapTradesIcon";
import ExpiryControls from "./expiryControls";
import StrikeControls from "./strikeControls";
import QuantityControls from "./quantityControls";
import { useSelector } from "react-redux";
import { selectAddOrderEnabled, selectTradeOrders } from "../../../selectors/strategyBuilder";
import { useDispatch } from "react-redux";
import { updateTradeOrders } from "../../../reducer/strategyBuilder.reducer";
import { OrderStatus, TransactionType } from "../../../proto/generated/order";
import { selectOrdersHistory } from "../../../selectors/orders";

const TradePanelControls: React.FC = () => {

    const dispatch = useDispatch()
    const tradeOrders = useSelector(selectTradeOrders);
    const addOrderEnabled = useSelector(selectAddOrderEnabled)
    const orderHistory = useSelector(selectOrdersHistory) || [];

    const orderHistoryMap = useMemo(() => orderHistory.reduce((map, order) => {
        map[order.orderId] = order;
        return map;
    }, {} as Record<string, typeof orderHistory[0]>), [orderHistory]);

    const swapOrders = useCallback(() => {
        dispatch(updateTradeOrders(tradeOrders.map(t => {

            return orderHistoryMap[t.referenceOrderId]?.status === OrderStatus.EXECUTED ? t :
             ({
            ...t,
            transactionType: t.transactionType === TransactionType.BUY ? TransactionType.SELL : TransactionType.BUY
        })})))
    }, [tradeOrders, orderHistoryMap])
    return <Stack id={'strategy-parameters'} marginBottom={1} direction="row" gap={1} justifyContent="center">
                    <Stack textAlign={'center'}>
                        <ExpiryControls disabled={!addOrderEnabled}/>
                    </Stack>
                    <Stack textAlign={'center'}>
                        <StrikeControls disabled={!addOrderEnabled} />
                    </Stack>
                    <Stack textAlign={'center'}>
                        <QuantityControls disabled={!addOrderEnabled} />
                    </Stack>
                    <Stack textAlign={'center'}>
                        <Typography variant="caption" color={'text.secondary'}
                            style={{ margin: '5px 0' }}>SWAP</Typography>
                        <Paper className="flex !rounded-sm relative items-center"
                            sx={{ background: (theme) => theme.palette.background.default }}>
                            <ExtraSmallButton data-event={'Swap Clicked'} data-event-source={'Trade'}
                                style={{ width: '50px' }}
                                disabled={!addOrderEnabled}
                                onClick={swapOrders}
                                className="button-icons"
                                color={'inherit'}
                                size={'small'}><SwapTradesIcon
                                    className="trade-panel-global-edit-icons" /></ExtraSmallButton>
                        </Paper>
                    </Stack>
                </Stack>
};


export default memo(TradePanelControls);